import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_27: FaireProductEntity = {
  token: "catalog_prod_prod-27",
  type: "product",
  name: "Accent Piece",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 73.99,
  msrpDollars: 184.98,
  sku: "PA0027",
  caseSize: 1,
  material: "Metal",
  collectionToken: "col_pattern-play",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 29,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_wall-decor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
